import Button from './Button.vue'

export { Button }
export default Button
